/**
 * SHOPIFY EPIC ACCESSIBILITY & SEO ENGINE
 * ---------------------------------------
 * VERSION: 6.0.0 (Marek Supplements Production Build - Refined)
 * CLIENT: Marek Supplements
 * TARGET: WCAG 2.2 Level AA & SEO Optimization
 */
window.ThemeEpic = (function($) {
    'use strict';
    let isProcessing = false;
    let lastBundleState = ''; // State tracker for Web Component mutations

    $(document).on('keydown', function(e) {
        if (e.key === 'Tab') { $('body').addClass('epic-is-tabbing'); }
    }).on('mousedown', function() {
        $('body').removeClass('epic-is-tabbing');
    });

    const epicConfig = {
        svgs: {
            external: '<svg class="epic-icon epic-icon-right" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/></svg>',
            close: '<svg class="epic-icon" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>',
            info: '<svg class="epic-icon epic-icon-left" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>',
            success: '<svg class="epic-icon epic-icon-success" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>'
        },
        mediaCaptionMap: (window.EpicThemeConfig && window.EpicThemeConfig.captions) ? window.EpicThemeConfig.captions : {}
    };

    const epicStrings = {
        'en': {
            skipMenu: 'Skip to Main Menu',
            skipContent: 'Skip to Content',
            skipFooter: 'Skip to Footer',
            success: 'Success',
            addedToCart: 'added to your cart',
            dismiss: 'Dismiss notification',
            variantUpdated: 'Variant updated to',
            newPrice: 'New price:',
            bundleUpdated: 'Bundle updated.',
            items: 'items.',
            total: 'Total:',
            removeFromBundle: 'Remove from bundle:',
            salePrice: 'Sale price:',
            originalPrice: 'Original price:',
            discount: 'Discount:',
            announcements: 'Announcements',
            selectedItems: 'Selected items',
            increaseQty: 'Increase quantity for',
            decreaseQty: 'Decrease quantity for'
        }
    };

    const t = (key) => {
        let lang = ($('html').attr('lang') || 'en').substring(0, 2).toLowerCase();
        return (epicStrings[lang] && epicStrings[lang][key]) ? epicStrings[lang][key] : (epicStrings['en'][key] || key);
    };

    const FocusRegistry = {
        cache: null,
        save: function() { this.cache = document.activeElement; },
        restore: function() { if (this.cache && typeof this.cache.focus === 'function') { this.cache.focus(); this.cache = null; } }
    };

    const executeMicroModules = () => {
        if (!$('html').attr('lang') || $('html').attr('lang').trim() === '') {
            $('html').attr('lang', (window.Shopify && window.Shopify.locale) ? window.Shopify.locale : 'en');
        }
        $('input[type="email"]:not([autocomplete])').attr('autocomplete', 'email');
        $('input[type="tel"]:not([autocomplete])').attr('autocomplete', 'tel');
        $('input[name*="firstname"], input[name*="first_name"]').not('[autocomplete]').attr('autocomplete', 'given-name');
        $('input[name*="lastname"], input[name*="last_name"]').not('[autocomplete]').attr('autocomplete', 'family-name');
        $('input[type="password"], input[type="email"], input[autocomplete="new-password"]').not('[name*="cc-number"], [name*="cvv"]').each(function() {
            $(this).removeAttr('onpaste ondrop oncopy');
        });
    };

    const runCorePipeline = () => {
        executeMicroModules();
        
        // 1. DEEP SCRUBBER & HEADING NORMALIZER (Resolves Item 4: Missing H1s dynamically)
        const normalizeHeadings = () => {
            // A. Dynamically check if a valid H1 exists on screen
            let $primaryH1 = $('h1').not('.header__logo, [aria-hidden="true"]').filter(':visible').first();
            
            if (!$primaryH1.length) {
                // Find the first true, visible H2 that actually has text (skipping empty helper tags!)
                let $firstH2 = $('h2').not('.header__logo, [aria-hidden="true"]').filter(function() {
                    return $(this).text().trim().length > 0 && $(this).is(':visible');
                }).first();

                if ($firstH2.length) {
                    // Promote to H1 while preserving all native theme classes, IDs, and data attributes
                    let $newH1 = $('<h1/>').html($firstH2.html());
                    $.each($firstH2[0].attributes, function(i, attr) { $newH1.attr(attr.name, attr.value); });
                    $firstH2.replaceWith($newH1);
                    $primaryH1 = $('h1').first();
                }
            }

            // B. Re-level sequential heading structure without skipping ranks
            let lastLevel = 1;
            $('h1, h2, h3, h4, h5, h6').not('.header__logo').each(function() {
                const $el = $(this);
                if (this.offsetWidth === 0 && this.offsetHeight === 0) return;
                if ($el.is($primaryH1)) { lastLevel = 1; return; }
                let cur = parseInt(this.tagName.substring(1)) || parseInt($el.attr('aria-level'));
                if (cur > lastLevel + 1) {
                    $el.attr({ 'role': 'heading', 'aria-level': lastLevel + 1 });
                    lastLevel++;
                } else { lastLevel = cur; }
            });
        };

        // 2. ADVANCED SKIP NAVIGATION ENFORCER
        const initSkipLinks = () => {
            if ($('.epic-skip-nav').length > 0) return;
            const menuTarget = $('header, .header-group, #shopify-section-header').first().attr('id') || 'epic-header-target';
            const contentTarget = $('main, [role="main"], #MainContent').first().attr('id') || 'epic-main-target';
            const footerTarget = $('footer, .footer-group').first().attr('id') || 'epic-footer-target';
            
            $('header').first().attr('id', menuTarget);
            $('main').first().attr('id', contentTarget);
            $('footer').first().attr('id', footerTarget);

            $('body').prepend(`
                <nav class="epic-skip-nav" aria-label="Skip navigation">
                    <a href="#${menuTarget}" class="epic-skip-link">${t('skipMenu')}</a>
                    <a href="#${contentTarget}" class="epic-skip-link">${t('skipContent')}</a>
                    <a href="#${footerTarget}" class="epic-skip-link">${t('skipFooter')}</a>
                </nav>
            `);
        };

        // 3. LANDMARK ENFORCER (Resolves Item 5: Landmark Duplication on Science Page)
        const enforceLandmarks = () => {
            $('header, .header-group').first().attr('role', 'banner');
            $('footer, .footer-group').first().attr('role', 'contentinfo');
            const $mains = $('main, #MainContent, [role="main"]');
            $mains.first().attr('role', 'main');
            if ($mains.length > 1) {
                $mains.not(':first').each(function() {
                    if ($(this).attr('role') === 'main') $(this).removeAttr('role');
                    if (this.tagName.toLowerCase() === 'main') {
                        $(this).attr('role', 'region');
                    }
                });
            }
            $('[role="main"] [role="main"], [role="banner"] [role="banner"]').removeAttr('role');
        };

        // 4. MAREK SUPPLEMENTS CUSTOM UI HYDRATION (Resolves Items 1, 3, & 6)
        const hydrateSupplementsUI = () => {
            // A. Scrollable Quicknav Focusability (Item 1)
            $('.collection-quicknav__people, .overflow-x-auto, .scrollable-region').each(function() {
                if (!$(this).attr('tabindex')) {
                    $(this).attr({ 'tabindex': '0', 'role': 'region', 'aria-label': 'Scrollable selector' });
                }
            });

            // B. Science Page Semantic Tablist Normalizer (Item 3)
            $('ul.formulas-nav__list[role="tablist"], [role="tablist"]').each(function() {
                $(this).find('li').attr('role', 'presentation');
                $(this).find('button, a').each(function(idx) {
                    const $control = $(this);
                    if (!$control.attr('role')) $control.attr('role', 'tab');
                    if (!$control.attr('id')) $control.attr('id', `tab-control-${idx}`);
                    const isSelected = $control.hasClass('is-active') || $control.hasClass('active') || $control.attr('aria-selected') === 'true';
                    $control.attr('aria-selected', isSelected ? 'true' : 'false');
                });
            });

            // C. Home Page Carousel Off-Screen Traps (Item 6)
            $('.flickity-slider, .slick-track, .swiper-wrapper').each(function() {
                const $track = $(this);
                $track.find('.flickity-cell:not(.is-selected), .slick-slide:not(.slick-active), .swiper-slide:not(.swiper-slide-active)').each(function() {
                    $(this).attr('aria-hidden', 'true').attr('tabindex', '-1').find('a, button, input, [tabindex]').attr('tabindex', '-1');
                });
                $track.find('.is-selected, .slick-active, .swiper-slide-active').each(function() {
                    $(this).removeAttr('aria-hidden').removeAttr('tabindex').find('a, button, input').not('.epic-handled').removeAttr('tabindex');
                });
            });
        };

        // 5. EXTERNAL LINK ROUTER (Resolves Item 8: CoA & External Tab Warnings)
        const hydrateExternalLinks = () => {
            const currentDomain = window.location.hostname;
            $('a[target="_blank"], a[href^="http"]:not([href*="' + currentDomain + '"]), a[href*="/pages/coa"]').not('.epic-handled-ext').each(function() {
                const $link = $(this).addClass('epic-handled-ext');
                $link.attr({ 'target': '_blank', 'rel': 'noopener noreferrer' });
                if ($link.find('.epic-ext-warning').length === 0) {
                    let payloadHtml = '<span class="sr-only"> (opens in a new tab)</span>';
                    if (!$link.is('.epic-img-link, .media-card__link')) payloadHtml = epicConfig.svgs.external + payloadHtml;
                    $link.append(`<span class="epic-ext-warning">${payloadHtml}</span>`);
                }
            });
        };

        // 6. ANIMATED TEXT SPLITTER SCRUBBER (Clears 14 WAVE flags & fixes SR stutter)
        const fixAnimatedText = () => {
            $('split-words:not([data-epic-hydrated]), .split-words:not([data-epic-hydrated])').each(function() {
                const $split = $(this);
                $split.attr('data-epic-hydrated', 'true');
                const fullText = $split.text().replace(/\s+/g, ' ').trim();
                $split.attr('aria-hidden', 'true');
                if (fullText !== '') {
                    $split.before(`<span class="sr-only">${fullText}</span>`);
                }
            });
        };

        // 7. DECORATIVE VIDEO CAPTION & ARIA SCRUBBER
        const fixDecorativeVideos = () => {
            $('video[autoplay], video-media video').each(function() {
                const $vid = $(this);
                $vid.attr({
                    'aria-hidden': 'true',
                    'tabindex': '-1',
                    'role': 'presentation'
                });
                if ($vid.find('track').length === 0) {
                    $vid.append('<track kind="captions" src="data:text/vtt;base64,V0VCVlRUCg==" srclang="en" label="English" default>');
                }
            });
        };
		// 7B. GLOBAL VIDEO POSTER & LIGHTBOX NORMALIZER (Catches Homepage Carousels)
        const normalizeVideoPosters = () => {
            $('.deferred-poster, [is="media-lightbox-button"], button.deferred-poster').each(function() {
                const $btn = $(this);
                if ($btn.attr('tabindex') === '-1' || !$btn.attr('tabindex')) {
                    $btn.attr('tabindex', '0');
                }
                // Strip illegal nested ARIA roles that confuse screen reader tab engines
                $btn.find('.play-button[role="button"], [role="button"]').removeAttr('role');
            });
        };

        // 8. SELF-HEALING PRICING & BUTTON CONTEXT (WCAG 1.3.1 & 2.4.4)
        const normalizeSupplementsUI = () => {
            // A. Sibling-Injection for Original / Strikethrough Prices (Immune to Web Component loops)
            $('s, del, .price__compare, [data-product-bundle-total-with-currency], [data-product-bundle-total]').each(function() {
                const $el = $(this);
                // Check if our label is already sitting cleanly BEFORE this element as a sibling
                if ($el.prev('.epic-price-label').length > 0 || $el.find('.epic-price-label').length > 0) return;
                
                if ($el.closest('.bundle-deal--unlocked, .price--on-sale, .price--sold-out, [data-bundle-discounted-total]').length || $el.is('s, del') || $el.hasClass('price__compare')) {
                    // Inject BEFORE the reactive element so RoarTheme never wipes it out
                    $el.before(`<span class="sr-only epic-price-label">${t('originalPrice') || 'Original price:'} </span>`);
                }
            });

            // B. Sibling-Injection for Active Sale / Discounted Prices (Immune to Web Component loops)
            $('.price__sale, [data-bundle-discounted-total], [data-bundle-discounted-total-mobile], .bundle-deal__newtotal').each(function() {
                const $el = $(this);
                if ($el.prev('.epic-price-label').length > 0 || $el.find('.epic-price-label').length > 0) return;
                
                // Inject BEFORE the reactive element so RoarTheme never wipes it out
                $el.before(`<span class="sr-only epic-price-label">${t('salePrice') || 'Sale price:'} </span>`);
            });

            // C. Contextualize Custom Remove Buttons
            $('product-bundle-remove-button:not([aria-label]), [data-action="remove"]:not([aria-label])').each(function() {
                const $btn = $(this);
                const itemName = $btn.closest('.horizontal-product, .cart-item').find('.horizontal-product__title, .cart-item__name').first().text().trim() || 'item';
                $btn.attr('aria-label', `${t('removeFromBundle') || 'Remove from bundle:'} ${itemName}`);
            });

            // D. Fix Concept Theme's Broken "{{ product }}" Liquid Output on Quantity Buttons
            $('.quantity__button[aria-label*="{{ product }}"]').each(function() {
                const $btn = $(this);
                const itemName = $btn.closest('.horizontal-product, .product-card').find('.horizontal-product__title, .product-card__title').first().text().trim() || 'item';
                const isPlus = $btn.attr('name') === 'plus' || $btn.hasClass('plus');
                $btn.attr('aria-label', `${isPlus ? (t('increaseQty') || 'Increase quantity for') : (t('decreaseQty') || 'Decrease quantity for')} ${itemName}`);
            });
			// E. Strip clobbering inline status roles inside dynamic cart drawers
				$('.free-shipping-bar__unlocked[role="status"], .marek-bundle-nudge[role="status"]').removeAttr('role');
        };

        // 9. STATE-TRACKING BUNDLE ANNOUNCER (Immune to Web Component AJAX trapping)
        const checkBundleMutations = () => {
            const $sidebar = $('.product-bundle__sidebar');
            if (!$sidebar.length || !$sidebar.is(':visible')) return;

            const goalText = $sidebar.find('.bundle-goal, [data-bundle-goal], [data-bundle-deal-msg]').filter(':visible').first().text().replace(/\s+/g, ' ').trim();
            
            let currentTotal = $sidebar.find('[data-bundle-discounted-total]').filter(':visible').first().text().trim();
            if (!currentTotal) {
                currentTotal = $sidebar.find('[data-product-bundle-total-with-currency]').filter(':visible').first().text().trim();
            }

            const currentState = `${goalText} | ${currentTotal}`;
            
            if (currentState !== ' | ' && currentState !== lastBundleState && lastBundleState !== '') {
                const speechPayload = `${t('bundleUpdated') || 'Bundle updated.'} ${goalText} ${currentTotal ? (t('total') || 'Total:') + ' ' + currentTotal : ''}`;
                announceToScreenReader(speechPayload.replace(/\|\s*/g, '').trim());
            }
            
            lastBundleState = currentState;
        };
		
		// 10. PDP MEDIA GALLERY REMEDIATION (Resolves RoarTheme trapped focus & keyboard zoom)
        const remediatePDPGallery = () => {
            // A. Untrap the Parent Block: Remove tabindex from the outer wrapper trapping focus
            $('.product__media-container[tabindex="0"], .product__gallery[tabindex="0"], [data-section-id*="main-product"] .product-gallery-wrapper[tabindex="0"]').removeAttr('tabindex');

            // B. Make Individual Media Items Interactive in the Tab Sequence
            $('.product__media-item, .product-gallery__thumbnail, [data-pswp-src], .pswp__img').each(function(index) {
                const $item = $(this);
                // Only target items that aren't already natively focusable buttons or anchors
                if (this.tagName !== 'BUTTON' && this.tagName !== 'A') {
                    if (!$item.attr('tabindex')) {
                        $item.attr({ 'tabindex': '0', 'role': 'button' });
                    }
                    if (!$item.attr('aria-label')) {
                        const altText = $item.attr('alt') || $item.find('img').attr('alt') || `Product image ${index + 1}`;
                        $item.attr('aria-label', `View ${altText} in gallery view`);
                    }
                }
            });

            // C. Bind Keyboard Actuation with Event Delegation (Immune to MutationObserver loops)
            $(document).off('keydown.epicGallery').on('keydown.epicGallery', '.product__media-item[role="button"], .product-gallery__thumbnail[role="button"], [data-pswp-src][role="button"], .pswp__img[role="button"]', function(e) {
                if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
                    e.preventDefault();
                    this.click(); // Fires RoarTheme's native slide-change or PhotoSwipe modal trigger
                }
            });
        };

        // Core Pipeline Execution
        normalizeHeadings();
        initSkipLinks();
        enforceLandmarks();
        hydrateSupplementsUI();
        hydrateExternalLinks();
        fixAnimatedText();
        fixDecorativeVideos();
		normalizeVideoPosters();
        normalizeSupplementsUI();
        checkBundleMutations();
		remediatePDPGallery();
    };

    // LIVE REGION ANNOUNCER (Upgraded with Priority Cooldown Lock)
    let speechLockTimer = null;
    let isSpeechLocked = false;

    const setupLiveRegion = () => {
        if (!$('#epic-live-region').length) {
            $('body').append('<div id="epic-live-region" aria-live="polite" aria-atomic="true" class="sr-only"></div>');
        }
    };

    const announceToScreenReader = (message, isPriorityAction = false) => {
        // If locked by a direct user click (like adding/removing items), ignore background AJAX noise!
        if (isSpeechLocked && !isPriorityAction) return;

        const $region = $('#epic-live-region');
        $region.text('');
        
        setTimeout(() => { 
            $region.text(message); 
            if (isPriorityAction) {
                isSpeechLocked = true;
                clearTimeout(speechLockTimer);
                speechLockTimer = setTimeout(() => { isSpeechLocked = false; }, 1500);
            }
        }, 100);
    };
	
	// DYNAMIC CART DRAWER ANNOUNCER (With Priority Lock to survive AJAX swaps)
    const initCartDrawerAnnouncer = () => {
        $(document).off('click.epicCartDrawer').on('click.epicCartDrawer', '.marek-stepper__btn, .marek-cart-remove', function(e) {
            const $btn = $(this);
            const $row = $btn.closest('.horizontal-product');
            const itemName = $row.find('.horizontal-product__title').first().text().trim() || 'Item';
            
            if ($btn.hasClass('marek-cart-remove') || $btn.is('[is="cart-remove-button"]')) {
                announceToScreenReader(`${itemName} removed from cart.`, true); // True = Lock region!
            } else if ($btn.hasClass('marek-stepper__btn--plus') || $btn.attr('name') === 'plus') {
                announceToScreenReader(`Increased quantity for ${itemName}.`, true);
            } else if ($btn.hasClass('marek-stepper__btn--minus') || $btn.attr('name') === 'minus') {
                announceToScreenReader(`Decreased quantity for ${itemName}.`, true);
            }
        });
    };

    // HYBRID CART NOTIFICATION (Upgraded with Bundle Builder Guard)
    const initHybridCart = () => {
        $(document).off('click.epicCart').on('click.epicCart', 'form[action*="/cart/add"] [type="submit"], .add-to-cart, [name="add"]', function(e) {
            if (!e.originalEvent) return;
            const $btn = $(this), $form = $btn.closest('form');
            
            // CRITICAL GUARD: Abort immediately if this is a RoarTheme Bundle Builder form!
            // This stops individual supplement cards from prematurely saying "added to your cart",
            // stepping aside so checkBundleMutations() can announce the actual sidebar numbers.
            if ($form.is('[is="product-bundle-form"]') || $form.closest('.product-bundle-wrapper, product-bundle').length > 0 || $btn.attr('aria-controls')?.includes('ProductBundle')) {
                return;
            }

            FocusRegistry.save();
            setTimeout(() => {
                if ($form.find('.product-form__error-message, .alert--error').filter(':visible').length > 0) return;
                const $activeDrawer = $('.is-open, .is-active, [aria-expanded="true"]').filter('.cart-drawer, #CartDrawer, .drawer');
                if ($activeDrawer.length > 0 && $activeDrawer.is(':visible')) {
                    $activeDrawer.find('h1, h2, h3, .drawer__title').first().attr('tabindex', '-1').focus();
                    return;
                }
                let productName = $form.find('[name="id"] option:selected').text() || $form.closest('.product, .card').find('.product-title, h1, h2').first().text() || "Item";
                const message = `${productName.replace(/\s+/g, ' ').trim()} ${t('addedToCart')}`;
                announceToScreenReader(message, true);
            }, 1000);
        });
    };

    // UPGRADED MUTATION OBSERVER (Watches for async node rendering & Web Components)
    const initObserver = () => {
        let debounceTimer;
        // Removing attributeFilter completely so it watches for newly rendered DOM nodes!
        const observerConfig = { 
            childList: true, 
            subtree: true, 
            attributes: true
        };
        const observer = new MutationObserver(() => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                observer.disconnect();
                runCorePipeline();
                requestAnimationFrame(() => { observer.observe(document.body, observerConfig); });
            }, 250);
        });
        observer.observe(document.body, observerConfig);
    };
	
    return {
        init: () => {
            setupLiveRegion();
            runCorePipeline();
            initHybridCart();
			initCartDrawerAnnouncer();
            initObserver();
            console.log('Epic Accessibility Engine v6.0.0 (Marek Supplements Build) Booted.');
        }
    };
})(window.jQuery || window.$);

document.addEventListener('DOMContentLoaded', () => {
    if (window.ThemeEpic && typeof window.ThemeEpic.init === 'function') { window.ThemeEpic.init(); }
});